var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader",class:[_vm.size, {'inverted': _vm.inverted }]})
}
var staticRenderFns = []

export { render, staticRenderFns }